<template>
  <div @click="showTable = true" class="tag-wrapper">
    <span
      v-if="client.clients_merged.length > 0"
      class="label tag-waiting table-tag-content"
      @click="showTable = true"
    >
      {{ client.clients_merged.length }} Merge
    </span>

    <div
      v-if="showTable"
      class="tag-table pop-up-for-tags"
      @mouseenter="showTable = false"
    >
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr v-for="item in client.clients_merged" :key="item.id">
              <td>{{ formatDateTable(item.updated_at) }}</td>
              <td>{{ item.updated_at | shortTime }}</td>
              <td>{{ item.user.full_name }}</td>
              <td>
                <a @click="$emit('merged', item.merged_client_id)">{{
                  item.merged_client_id
                }}</a>
              </td>
              <td>
                <span v-if="item.comments">{{
                  item.comments | truncate(160)
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Merged",
  props: {
    client: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showTable: false
    };
  },
  created() {
    window.addEventListener("click", this.closeTable);
  },

  methods: {
    closeTable(e) {
      if (!this.$el.contains(e.target)) {
        this.showTable = false;
      }
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM ");
    }
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
}

.tag-wrapper {
  display: inline-flex;
  position: relative;
  text-align: center;
  cursor: pointer;
}

.tag-waiting {
  /*background-color: #1c2529;*/
  /*font-size: 12px;*/
  /*color: white;*/
  /*margin: 2px;*/
  /*padding: 3px;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  background-color: #1c2529;
  /*font-size: 12px;*/
  /*color: white;*/
  /*font-weight: 400;*/
  /*text-transform: uppercase;*/
  /*margin: 2px;*/
  /*!*padding: 3px;*!*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
}

.tag-table {
  bottom: 21px !important;

  border: solid 1px #1c2529;
}

.table {
  margin-bottom: unset;
}

.table-responsive {
  margin-bottom: 0;
  border-radius: 5px;
}
.table-tag-content {
  min-width: 49px !important;
}
</style>
